<script setup lang="ts">
withDefaults(defineProps<{ height?: string; radius?: string }>(), {
  height: '20px',
  radius: 'var(--r-sm)',
});
</script>

<template>
  <div class="sk" :style="{ height, borderRadius: radius }" />
</template>

<style scoped>
.sk {
  background: linear-gradient(
    90deg,
    var(--bg-elevated) 0%,
    var(--bg-overlay) 50%,
    var(--bg-elevated) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
